import type { ReactNode } from 'react';
import { WEB_ICO } from '../shell/icons';
import { useViewport } from '../shell/useViewport';

const FEATURES: [string, string][] = [
  ['Lộ trình rõ ràng', 'Hiragana → Katakana → Bộ thủ → hai nhánh Từ vựng & Ngữ pháp'],
  ['Ôn tập ngắt quãng (SRS)', 'Ôn tập theo chu kỳ giãn cách để nhớ lâu với ít công sức nhất'],
  ['Học cùng cộng đồng', 'Cùng học với người Việt khác — thi đua streak và hỏi đáp mỗi ngày'],
];

/**
 * Khung trang đăng nhập/đăng ký: panel thương hiệu bên trái + form bên phải. Trên điện
 * thoại (< 640px) hai cột xếp chồng: dải thương hiệu gọn ở trên (bỏ danh sách tính năng),
 * form rộng hết màn ở dưới.
 */
export function WebAuthLayout({ children }: { children?: ReactNode }) {
  const { phone } = useViewport();
  return (
    <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: phone ? 'column' : 'row', fontFamily: 'var(--font-vi)', background: 'var(--surface-page)' }}>
      <div
        style={{
          flex: phone ? 'none' : '1 1 45%',
          minWidth: 0,
          background: 'linear-gradient(150deg,#011f4b,#03396c)',
          color: '#fff',
          padding: phone ? 'calc(24px + env(safe-area-inset-top, 0px)) 20px 24px' : '56px 56px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: phone ? 14 : 28,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            width: 520,
            height: 520,
            right: -160,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'radial-gradient(circle, rgba(242,128,59,0.3), transparent 62%)',
            pointerEvents: 'none',
          }}
        />
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src="/assets/torii-mark.svg" alt="" style={{ width: 34, height: 34, filter: 'brightness(0) invert(1)' }} />
          <span style={{ fontSize: 20, fontWeight: 700, letterSpacing: 2 }}>TORII</span>
        </div>
        <div style={{ position: 'relative' }}>
          <h1 style={{ fontSize: phone ? 24 : 34, fontWeight: 700, lineHeight: 1.25, margin: 0, maxWidth: 440, textWrap: 'pretty' }}>
            Học một ngôn ngữ, mở một thế giới
          </h1>
          <p style={{ fontSize: phone ? 14 : 15.5, lineHeight: 1.6, color: 'var(--navy-100)', maxWidth: 420, marginTop: phone ? 8 : 16, marginBottom: 0 }}>
            Lộ trình tiếng Nhật từ 0 đến N5 dành cho người Việt. Sai không bị trừ điểm — bạn cứ thử thoải mái.
          </p>
        </div>
        {!phone && (
          <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 420 }}>
          {FEATURES.map(([title, sub]) => (
            <div key={title} style={{ display: 'flex', gap: 12 }}>
              <span
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.14)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  marginTop: 2,
                }}
              >
                {WEB_ICO.check('#fff', 14)}
              </span>
              <span>
                <span style={{ display: 'block', fontSize: 14.5, fontWeight: 700 }}>{title}</span>
                <span style={{ display: 'block', fontSize: 13.5, color: 'var(--navy-100)', lineHeight: 1.5, marginTop: 2 }}>{sub}</span>
              </span>
            </div>
          ))}
          </div>
        )}
      </div>
      <div
        style={{
          flex: phone ? '1 0 auto' : '1 1 55%',
          minWidth: 0,
          display: 'flex',
          alignItems: phone ? 'flex-start' : 'center',
          justifyContent: 'center',
          padding: phone ? '24px 20px calc(32px + env(safe-area-inset-bottom, 0px))' : '48px 32px',
          overflowY: 'auto',
        }}
      >
        {children}
      </div>
    </div>
  );
}
